module.exports = __webpack_public_path__ + "static/media/Rajal Vaidya.7f2f09ff.jpg";